/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { OverviewRoutePermissionsService } from '../overview-route-permissions.service';
import { ThemePalette } from '@angular/material/core';
import { OverviewToolbarActions } from '@midas/shared/data-access';
import { Subject } from 'rxjs';

interface OrgRouteSection {
  name: string;
  expanded: boolean;
  routes: OrgRoute[];
}

interface OrgRoute {
  path: string;
  name: string;
  icon: string;
  suffix?: { color: ThemePalette; text: string; value: number };
}

export const expandedOrgSideNav$ = new BehaviorSubject<boolean>(
  localStorage.getItem('ui-sidenav-mode') === 'expand' ? true : false,
);

@Component({
  selector: 'midas-overview-shell',
  templateUrl: './overview-shell.component.html',
  styleUrls: ['./overview-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    RouterModule,
    MatExpansionModule,
    TranslocoModule,
    MatTooltipModule,
    MatBadgeModule,
  ],
})
export default class OverviewShellComponent implements OnInit, OnDestroy {
  private _destroy$!: Subject<void>;
  sections: OrgRouteSection[] = [];
  activeRoute?: OrgRoute;
  expandedOrgSideNav$ = expandedOrgSideNav$;

  readonly routes$ = inject(OverviewRoutePermissionsService).getAllowedRoutes();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(OverviewToolbarActions.changeSpace({ data: { space: 'overview' } }));
  }

  ngOnDestroy(): void {
    if (this._destroy$) {
      this.store.dispatch(OverviewToolbarActions.changeSpace({ data: { space: 'org' } }));
      this._destroy$.next();
      this._destroy$.complete();
    }
  }

  public get destroy$(): Subject<void> {
    if (!this._destroy$) {
      this._destroy$ = new Subject();
    }
    return this._destroy$;
  }
}
